import { render, staticRenderFns } from "./MapList.vue?vue&type=template&id=a536c654&scoped=true"
import script from "./MapList.vue?vue&type=script&lang=ts"
export * from "./MapList.vue?vue&type=script&lang=ts"
import style0 from "./MapList.vue?vue&type=style&index=0&id=a536c654&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a536c654",
  null
  
)

export default component.exports